import { z } from 'zod';

// All entity number unique identifiers are documented here:
// https://schuettflix.atlassian.net/wiki/spaces/Engineerin/pages/1952972805/Entity+Numbers+Unique+Identifiers

export const ProjectNumberSchema = z.string().regex(/^PJ?\d{2}-\d{5}$/, {
    message: 'Project number must follow the format PJXX-XXXXX where X are digits',
});

export type ProjectNumber = z.infer<typeof ProjectNumberSchema>;

export const ProjectPositionNumberSchema = z.string().regex(/^PJ?\d{2}-\d{5}-[5-9]\d{2}$/, {
    message: 'Project Position Number must follow the format PJ24-00100-XXX where XXX are digits and XXX >= 500',
});
export type ProjectPositionNumber = z.infer<typeof ProjectPositionNumberSchema>;

export const LegacyProjectPositionNumberSchema = z.string().regex(/^PJ?\d{2}-\d{5}-[0-4]\d{2}$/, {
    message: 'Project Position Number must follow the format PJ24-00100-XXX where XXX are digits and XXX >= 500',
});

export const POSITION_STATUS_SCHEMA = z.enum(['OPEN', 'CLOSED']);
export type POSITION_STATUS = z.infer<typeof POSITION_STATUS_SCHEMA>;
